module.exports = __webpack_public_path__ + "img/canva.075172a3.png";